import { upload } from '@vercel/blob/client';
import { compressImage } from './compressImage';

const uploadMultiPalImage = async (file) => {
  const compressedFile = await compressImage(file);
  const newBlob = await upload(compressedFile.name, compressedFile, {
    access: 'public',
    handleUploadUrl: `${process.env.REACT_APP_BASE_URL}api/image/upload`,
  });
  return newBlob;
}

export default uploadMultiPalImage;